const getDateListYears = (currentYear) => {
  return Array(100)
    .fill()
    .map((ele, i) => {
      const value = currentYear - i;
      return {
        label: <span className="lato">{value}</span>,
        value: "" + value,
      };
    })
    .sort((a, b) => b - a);
};
export const getHijriYearOfBirthList = () => {
  const currentYear = new Date().getFullYear();
  const hijriYear = Math.round((currentYear - 623) * (33 / 32));
  return getDateListYears(hijriYear);
};
export const getGregYearOfBirthList = () => {
  const gregYear = new Date().getFullYear();
  return getDateListYears(gregYear);
};

export const getNumberRepresentedLanguageCode = (language) => {
  return isArabic(language) ? "1" : "2";
};

// language > 'en' or 'ar'
export const getOneLetterLanguageCode = (language) => {
  return language.slice(0, 1).toUpperCase();
};

// language > 'en' or 'ar'
export const getTwoLetterLanguageCode = (language) => {
  return language.toUpperCase();
};

export const isSaudi = (nationalId) => {
  return nationalId && nationalId[0] === "1";
};

export const numberWithCommas = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isValidSaudiIDOrIQama = (idNumber) => {
  return /^[1,2]{1}[0-9]{9}$/i.test(idNumber);
};

export const isValidSaudiPhoneNumber = (value) => {
  return /^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/.test(value);
};

export const isArabic = (language) => {
  return language === "ar";
};

export const prepareMobileNumber = (value) => {
  if (value?.indexOf("+966") === 0 || value?.indexOf("966") === 0) {
    return value;
  }
  return "+966" + value;
};

export const numbersOnly = (event) => {
  const regex = /[0-9]+/g;
  return regex.test(event.key);
};

export const getProductsCodes = () => {
  return {
    SANAD: "MotorImtiazeTP",
    SANAD_PLUS: "PRMotorImtiazeSP",
    AL_SHAMEL: "PRMotorImtiazeCO",
  };
};

export const hijriDays = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
  { label: "25", value: "25" },
  { label: "26", value: "26" },
  { label: "27", value: "27" },
  { label: "28", value: "28" },
  { label: "29", value: "29" },
  { label: "30", value: "30" },
];

export const mechanicalFeatures = [
  {
    label: "engine",
    price: "20,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "gearbox",
    price: "10,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "differential",
    price: "10,000",
    codes: ["MC_GD", "MC_SI", "MC_ST"],
  },
  {
    label: "turbo-assembly",
    price: "5,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "management-system",
    price: "5,000",
    codes: ["MC_GD", "MC_SI"],
  },

  {
    label: "prop-shaft-CV-joints",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },

  {
    label: "steering-mechanism",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "wheel-bearings",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "braking-system",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "fuel-system",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "electrical-components",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "electrical-ignition",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "suspension",
    price: "4,000",
    codes: ["MC_GD", "MC_SI"],
  },
  {
    label: "cylinder-head-gasket",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "radiator",
    price: "4,000",
    codes: ["MC_GD"],
  },

  {
    label: "air-conditioner",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "overheating",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "cambelt-failure",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "clutch",
    price: "4,000",
    codes: ["MC_GD"],
  },
  {
    label: "electric-fans-sunroof",
    price: "4,000",
    codes: ["MC_GD"],
  },
];

export const getPercentageValues = (value, size) => {
  let chunks = [];
  let sum = value;
  if (size === 1) {
    return [value];
  } else {
    for (let i = 0; i < size; i++) {
      if ((value / size) % 1 !== 0) {
        if (sum > 75) {
          sum -= 50;
        } else if (sum > 25) {
          sum -= 25;
        }
        chunks[i] = sum;
      } else {
        chunks[i] = value / size;
      }
    }
    return chunks;
  }
};

export const generateSha256Hash = async (email) => {
  const utf8 = new TextEncoder().encode(email);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
};
export const months = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export const months_hijri_en = [
  { label: "Muharram", value: "01" },
  { label: "Safar", value: "02" },
  { label: "Rabi' al-Awwal", value: "03" },
  { label: "Rabi' al-Thani", value: "04" },
  { label: "Jumada al-Awwal", value: "05" },
  { label: "Jumada al-Thani", value: "06" },
  { label: "Rajab", value: "07" },
  { label: "Sha'ban", value: "08" },
  { label: "Ramadan", value: "09" },
  { label: "Shawwal", value: "10" },
  { label: "Dhu al-Qi'dah", value: "11" },
  { label: "Dhu al-Hijjah", value: "12" },
];

export const months_hijri_ar = [
  { label: "محرم", value: "01" },
  { label: "صفر", value: "02" },
  { label: "ربيع الأوّل", value: "03" },
  { label: "ربيع الآخر", value: "04" },
  { label: "جمادى الأولى", value: "05" },
  { label: "جمادى الآخرة", value: "06" },
  { label: "رجب", value: "07" },
  { label: "شعبان", value: "08" },
  { label: "رمضان", value: "09" },
  { label: "شوّال", value: "10" },
  { label: "ذو القعدة", value: "11" },
  { label: "ذو الحجة", value: "12" },
];

export const BUSINESS_LINE_PATHS = {
  STC: "stc",
  DEFAULT: undefined,
};
export const BUSINESS_LINE_COLORS = {
  STC: "#4F008C",
  DEFAULT: "#6B47F5",
};
